import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const isDownloadingLoyaltyProducts = createSelector(membersState, (members) => members.loyaltyProducts.isDownloading);
